import React from 'react';
import { DimensionValue, StyleProp, ViewStyle } from 'react-native';
import Stack from './Stack';

export type RestrictedWidthVariant = 'default' | 'lg' | 'sm' | 'xs' | 'md';

export type MaxWidthRestrictedContentOwnProps = {
    children: any;
    style?: StyleProp<ViewStyle>;
    contentContainerStyle?: StyleProp<ViewStyle>;
    maxWidth?: number;
    variant?: RestrictedWidthVariant;
};

export type MaxWidthRestrictedContentProps = MaxWidthRestrictedContentOwnProps;

export const DEFAULT_MAX_WIDTH = 800;

const maxWidthMap: Record<RestrictedWidthVariant, DimensionValue> = {
    default: DEFAULT_MAX_WIDTH,
    md: 1100,
    lg: '100%',
    sm: 700,
    xs: 400,
};

const MaxWidthRestrictedContent: React.FC<MaxWidthRestrictedContentProps> = (props) => {
    const maxWidth: DimensionValue = props.maxWidth ? props.maxWidth : maxWidthMap[props.variant || 'default'];

    return (
        <Stack horizontal fullWidth justify={'center'} style={props.style}>
            <Stack
                vertical
                fullWidth
                justify={'center'}
                style={[
                    {
                        maxWidth,
                    },
                    props.contentContainerStyle,
                ]}
                testID="max-width-restricted-content"
            >
                {props.children}
            </Stack>
        </Stack>
    );
};

export default React.memo(MaxWidthRestrictedContent);
